import { Button } from '@folio/stripes/components';
import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';
import { HeaderFooterTokenType } from '../../types';
import { HeaderFooterCard } from '../Token';
export default function HeaderFooterSection(_a) {
    var name = _a.name;
    return (React.createElement(FieldArray, { name: name }, function (_a) {
        var fields = _a.fields;
        return (React.createElement(React.Fragment, null,
            fields.map(function (innerName, index) { return (React.createElement(HeaderFooterCard, { key: innerName, fieldArrayName: name, name: innerName, index: index, isLast: index + 1 === fields.length })); }),
            React.createElement(Button, { onClick: function () { return fields.push({ type: HeaderFooterTokenType.NEWLINE }); } },
                React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.button.add" }))));
    }));
}
